import { useEffect, useRef, useState } from 'react'
// import {useProductStore} from '../states/product.state'
import { KTCard } from '../../../../../_metronic/helpers'
import { UsersListLoading } from '../../user-management/users-list/components/loading/UsersListLoading'
import { generateCurrencyFormat } from '../../../../helpers/generate-currency-format'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import { useProductStore } from '../../products/states/product.state'
import { useSettlementStore } from '../states/settlement.state'
import { generateStatus, generateType } from '../../../../helpers/generate-status'
import Flatpickr from 'react-flatpickr'
import { StatisticsWidget5 } from '../../../../../_metronic/partials/widgets'
import { generateNumberFormat } from '../../../../helpers/generate-number-format'
import { useSettlementShopeeStore } from '../states/settlement-shopee.state'

const SettlementShopeeListComponent = () => {
  const {
    getSettlements,
    settlementLoading,
    settlements,
    settlementModel,
    getTotalSettlement,
    totalSettlementLoading,
    totalSettlements,
    generateExportLoading,
    totalUnsettled,
    totalProducts,
    totalFreeProducts,
    getGenerateExport,
  } = useSettlementShopeeStore()

  const flatpickrRef = useRef<Flatpickr>(null)
  // const [filters, setFilters] = useState<any[]>([])
  // const [statementId, setStatementId] = useState<string>()
  const [search, setSearch] = useState<string>()
  const [statementId, setStatementId] = useState<string>()
  const [statusLabel, setStatusLabel] = useState<string>()
  const [typeLabel, setTypeLabel] = useState<string>()
  const [startTime, setStartTime] = useState<Date>(null)
  const [endTime, setEndTime] = useState<Date>(null)
  const [sort, setSort] = useState<string>('escrow_release_time')
  const [order, setOrder] = useState<string>('-')
  const [orderTime, setOrderTime] = useState<Date>(null)
  const [orderEndTime, setOrderEndTime] = useState<Date>(null)

  const resetData = () => {
    setStartTime(null)
    setEndTime(null)
    setOrderTime(null)
    setOrderEndTime(null)
    setSearch('')
    setStatusLabel('')
    setTypeLabel('')
    setOrder('escrow_release_time')
    setSort('-')
  }

  useEffect(() => {
    // getSettlements({
    //   sort: '-escrow_release_time',
    //   page: 0,
    //   size: 10,
    // })
    // getTotalSettlement({})
  }, [])

  const filterData = () => {
    startTime?.setHours(0, 0, 0, 0)
    endTime?.setHours(23, 59, 59, 0)
    const sDate = Math.floor(startTime?.getTime() / 1000)
    const eDate = Math.floor(endTime?.getTime() / 1000)

    orderTime?.setHours(0, 0, 0, 0)
    orderEndTime?.setHours(23, 59, 59, 0)
    const sOrderTime = Math.floor(orderTime?.getTime() / 1000)
    const sOrderEndTime = Math.floor(orderEndTime?.getTime() / 1000)

    getSettlements({
      type: typeLabel ?? undefined,
      sort: `${order}${sort}`,
      start_date_statement: isNaN(sDate) ? undefined : sDate,
      end_date_statement: isNaN(eDate) ? undefined : eDate,
      start_date: isNaN(sOrderTime) ? undefined : sOrderTime,
      end_date: isNaN(sOrderEndTime) ? undefined : sOrderEndTime,
      order_id: search ?? undefined,
      status: statusLabel ?? undefined,
      size: 10,
      page: 0,
    })
    getTotalSettlement({
      type: typeLabel ?? undefined,
      sort: `${order}${sort}`,
      start_date_statement: isNaN(sDate) ? undefined : sDate,
      end_date_statement: isNaN(eDate) ? undefined : eDate,
      start_date: isNaN(sOrderTime) ? undefined : sOrderTime,
      end_date: isNaN(sOrderEndTime) ? undefined : sOrderEndTime,
      order_id: search ?? undefined,
      status: statusLabel ?? undefined,
      size: 10,
      page: 0,
    })
  }

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected

    startTime?.setHours(0, 0, 0, 0)
    endTime?.setHours(23, 59, 59, 0)
    const sDate = Math.floor(startTime?.getTime() / 1000)
    const eDate = Math.floor(endTime?.getTime() / 1000)

    orderTime?.setHours(0, 0, 0, 0)
    orderEndTime?.setHours(23, 59, 59, 0)
    const sOrderTime = Math.floor(orderTime?.getTime() / 1000)
    const sOrderEndTime = Math.floor(orderEndTime?.getTime() / 1000)

    getSettlements({
      type: typeLabel ?? undefined,
      sort: `${order}${sort}`,
      start_date_statement: isNaN(sDate) ? undefined : sDate,
      end_date_statement: isNaN(eDate) ? undefined : eDate,
      start_date: isNaN(sOrderTime) ? undefined : sOrderTime,
      end_date: isNaN(sOrderEndTime) ? undefined : sOrderEndTime,
      order_id: search ?? undefined,
      status: statusLabel ?? undefined,
      size: 10,
      page: selectedPage,
    })
  }

  return (
    <>
      <KTCard className='p-3 mb-5'>
        <div className='card-body'>
          <div className='row'>
            <div className='col-sm-4'>
              <label className='form-label'>Order ID</label>
              <input
                onChange={(e) => setSearch(e.target.value)}
                placeholder='ID Pesanan'
                value={search}
                className={'form-control'}
                type='text'
              />
            </div>
            <div className='col-sm-4'>
              <label className='form-label'>Status Label:</label>
              <select
                className='form-select fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='role'
                data-hide-search='true'
                onChange={(e) => setStatusLabel(e.target.value)}
                value={statusLabel}
              >
                <option value=''></option>
                <option value='AWAITING_COLLECTION'>{generateStatus('AWAITING_COLLECTION')}</option>
                <option value='AWAITING_SHIPMENT'>{generateStatus('AWAITING_SHIPMENT')}</option>
                <option value='CANCELLED'>{generateStatus('CANCELLED')}</option>
                <option value='UNPAID'>{generateStatus('UNPAID')}</option>
                <option value='IN_TRANSIT'>{generateStatus('IN_TRANSIT')}</option>
                <option value='COMPLETED'>{generateStatus('COMPLETED')}</option>
                <option value='DELIVERED'>{generateStatus('DELIVERED')}</option>
              </select>
            </div>
            <div className='col-sm-4'>
              <label className={`form-label`}>Settlement Range</label>
              <Flatpickr
                ref={flatpickrRef}
                value={[startTime, endTime]}
                onChange={([date1, date2]) => {
                  setStartTime(date1)
                  setEndTime(date2)
                }}
                options={{
                  mode: 'range',
                  altInput: true,
                }}
                className='form-control'
                placeholder='Pick date'
              />
            </div>
            <div className='col-sm-4'>
              <label className={`form-label`}>Order Range</label>
              <Flatpickr
                ref={flatpickrRef}
                value={[orderTime, orderEndTime]}
                onChange={([date1, date2]) => {
                  setOrderTime(date1)
                  setOrderEndTime(date2)
                }}
                options={{
                  mode: 'range',
                  altInput: true,
                }}
                className='form-control'
                placeholder='Pick date'
              />
            </div>
            <div className='col-sm-4'>
              <label className='form-label'>Type Label:</label>
              <select
                className='form-select fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='role'
                data-hide-search='true'
                onChange={(e) => setTypeLabel(e.target.value)}
                value={typeLabel}
              >
                <option value=''></option>
                <option value='ORDER'>{generateType('ORDER')}</option>
                <option value='PLATFORM_REIMBURSEMENT'>
                  {generateType('PLATFORM_REIMBURSEMENT')}
                </option>
                <option value='LOGISTICS_REIMBURSEMENT'>
                  {generateType('LOGISTICS_REIMBURSEMENT')}
                </option>
                <option value='DEDUCTIONS_INCURRED_BY_SELLER'>
                  {generateType('DEDUCTIONS_INCURRED_BY_SELLER')}
                </option>
              </select>
            </div>
            <div className='col-sm-4'>
              <label className='form-label'>Sort By:</label>
              <select
                className='form-select fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='role'
                data-hide-search='true'
                onChange={(e) => setSort(e.target.value)}
                value={sort}
              >
                <option value='escrow_release_time'>{'Waktu Statement'}</option>
                <option value='create_time'>{'Waktu Order'}</option>
                <option value='payout_amount'>{'Settlement Amount'}</option>
              </select>
            </div>
            <div className='col-sm-4'>
              <label className='form-label'>Order:</label>
              <select
                className='form-select fw-bolder'
                data-kt-select2='true'
                data-placeholder='Select option'
                data-allow-clear='true'
                data-kt-user-table-filter='role'
                data-hide-search='true'
                onChange={(e) => setOrder(e.target.value)}
                value={order}
              >
                <option value='-'>{'DESC'}</option>
                <option value=''>{'ASC'}</option>
              </select>
            </div>
          </div>
        </div>
        <div className='card-footer'>
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={generateExportLoading}
              onClick={(e) => {
                startTime?.setHours(0, 0, 0, 0)
                endTime?.setHours(23, 59, 59, 0)
                const sDate = Math.floor(startTime?.getTime() / 1000)
                const eDate = Math.floor(endTime?.getTime() / 1000)

                orderTime?.setHours(0, 0, 0, 0)
                orderEndTime?.setHours(23, 59, 59, 0)
                const ssDate = Math.floor(orderTime?.getTime() / 1000)
                const eeDate = Math.floor(orderEndTime?.getTime() / 1000)

                getGenerateExport({
                  type: typeLabel ?? undefined,
                  sort: `${order}${sort}`,
                  start_date_statement: isNaN(sDate) ? undefined : sDate,
                  end_date_statement: isNaN(eDate) ? undefined : eDate,
                  start_date: isNaN(ssDate) ? undefined : ssDate,
                  end_date: isNaN(eeDate) ? undefined : eeDate,
                  order_id: search ?? undefined,
                  status: statusLabel ?? undefined,
                })
              }}
              className='btn btn-success btn-active-success-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Export
            </button>
            <button
              type='button'
              disabled={settlementLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
            <button
              disabled={settlementLoading}
              type='button'
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
          </div>
        </div>
      </KTCard>

      <div className='alert alert-danger d-flex align-items-center p-5'>
        <div className="d-flex flex-column">
          <span>Data akan tampil jika sudah diklik <b>Apply</b></span>
        </div>
      </div>

      <div className='row g-5 g-xl-4'>
        <div className='col-xl-6'>
          <StatisticsWidget5
            className='card-xl-stretch mb-6'
            svgIcon='chart-simple'
            color='white'
            iconColor='primary'
            title={`${generateNumberFormat(totalSettlements ?? 0)}`}
            description={totalSettlementLoading ? `Loading...` : `Total Settlement`}
          />
        </div>
        <div className='col-xl-6'>
          <KTCard
            className='mb-6'>
            <div style={{
              paddingTop: 16,
              paddingLeft: 16,
              paddingRight: 16
            }}>
              <h4>Data order yang belum settle berdasarkan status</h4>
            </div>
            <div className='table-responsive'>
              <table className='table table-row-bordered table-striped table-hover table-row-gray-100 align-middle gs-3 gy-3'>
                <thead>
                  <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                    <th>Status</th>
                    <tr>Total</tr>
                  </tr>
                </thead>
                <tbody className='text-gray-600 fw-semibold'>
                  {
                    totalUnsettled?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.status}</td>
                        <td>{generateCurrencyFormat(item.total_amount || 0)}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </KTCard>
        </div>
        <div className='col-xl-12'>
          <KTCard className='mb-6'>
            <div className='card-header border-0 pt-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bold fs-3 mb-1'>Data Product by Status</span>
                <span className='text-muted mt-1 fw-semibold fs-7'>
                  {totalProducts?.reduce((acc, group) => acc + (group.products?.length || 0), 0)} products across {totalProducts?.length || 0} statuses
                </span>
              </h3>
            </div>
            <div className='card-body py-3'>
              <div className='accordion' id='kt_accordion_products'>
                {totalProducts?.map((statusGroup, statusIndex) => {
                  const totalQty = statusGroup.products?.reduce((sum, p) => sum + (p.total_qty || 0), 0) || 0
                  return (
                    <div className='accordion-item mb-3' key={statusIndex}>
                      <h2 className='accordion-header' id={`kt_accordion_header_${statusIndex}`}>
                        <button
                          className={`accordion-button fs-4 fw-semibold ${statusIndex === 0 ? '' : 'collapsed'}`}
                          type='button'
                          data-bs-toggle='collapse'
                          data-bs-target={`#kt_accordion_body_${statusIndex}`}
                          aria-expanded={statusIndex === 0 ? 'true' : 'false'}
                          aria-controls={`kt_accordion_body_${statusIndex}`}
                        >
                          <div className='d-flex align-items-center justify-content-between w-100 me-3'>
                            <span>
                              <span className='badge badge-light-primary me-2'>{statusGroup.products?.length || 0}</span>
                              {generateStatus(statusGroup.status)}
                            </span>
                            <span className='text-muted fs-6 fw-semibold'>
                              Total: {generateNumberFormat(totalQty)} items
                            </span>
                          </div>
                        </button>
                      </h2>
                      <div
                        id={`kt_accordion_body_${statusIndex}`}
                        className={`accordion-collapse collapse ${statusIndex === 0 ? 'show' : ''}`}
                        aria-labelledby={`kt_accordion_header_${statusIndex}`}
                        data-bs-parent='#kt_accordion_products'
                      >
                        <div className='accordion-body p-0'>
                          <div className='table-responsive'>
                            <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 mb-0'>
                              <thead>
                                <tr className='fw-bold text-muted bg-light'>
                                  <th className='ps-4 min-w-300px rounded-start'>Nama Product</th>
                                  <th className='min-w-125px text-end pe-4 rounded-end'>Jumlah QTY</th>
                                </tr>
                              </thead>
                              <tbody>
                                {statusGroup.products?.map((item, productIndex) => (
                                  <tr key={productIndex}>
                                    <td className='ps-4'>
                                      <span className='text-dark fw-bold d-block fs-6'>{item.product_name}</span>
                                      <span className='text-muted fw-semibold text-muted d-block fs-7'>ID: {item._id}</span>
                                    </td>
                                    <td className='text-end pe-4'>
                                      <span className='badge badge-light-success fs-7 fw-bold'>
                                        {generateNumberFormat(item.total_qty || 0)}
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </KTCard>
        </div>


        <div className='col-xl-12'>
          <KTCard
            className='mb-6'>
            <div style={{
              paddingTop: 16,
              paddingLeft: 16,
              paddingRight: 16
            }}>
              <h4>Data Free Product</h4>
            </div>
            <div className='table-responsive'>
              <table className='table table-row-bordered table-striped table-hover table-row-gray-100 align-middle gs-3 gy-3'>
                <thead>
                  <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                    <th>Nama Product</th>
                    <tr>Jumlah QTY</tr>
                  </tr>
                </thead>
                <tbody className='text-gray-600 fw-semibold'>
                  {
                    totalFreeProducts?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.product_name}</td>
                        <td>{generateNumberFormat(item.total_qty || 0)}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </KTCard>
        </div>
      </div>

      <KTCard>
        <div className='card-body py-3'>
          <div className='table-responsive'>
            {settlementLoading && <UsersListLoading />}
            <table className='table table-row-bordered table-striped table-hover table-row-gray-100 align-middle gs-3 gy-3'>
              <thead>
                <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                  <th>Order ID</th>
                  <th>Status Pesanan</th>
                  <th>Pembeli</th>
                  <th>Waktu Pesanan</th>
                  <th>Waktu Settlement</th>
                  <th>Produk</th>
                  <th>Order Amount</th>
                  <th>Admin Fee</th>
                  <th>Settlement Amount</th>
                </tr>
              </thead>
              <tbody className='text-gray-600 fw-semibold'>
                {settlements?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>
                        <div className='d-flex align-items-center'>
                          <div className='d-flex flex-column'>
                            <b>{item.order_sn}</b>
                          </div>
                        </div>
                      </td>
                      <td>
                        <b>{generateStatus(item.orders?.order_status ?? 'UNPAID')}</b>
                      </td>
                      <td>
                        <span>{item?.orders?.buyer_username}</span>
                      </td>
                      <td>
                        {moment(item?.orders?.create_time * 1000).format('DD/MM/YYYY HH:mm:ss')}
                      </td>
                      <td>
                        {moment(item?.escrow_release_time * 1000).format('DD/MM/YYYY HH:mm:ss')}
                      </td>
                      <td>
                        <div className='d-flex flex-column'>
                          <span>
                            <b>{item.orders?.item_list?.length}</b>{' '}
                            {item.orders?.item_list?.length > 0 ? 'produk' : ''}
                          </span>
                          {item.orders?.item_list?.length > 0 ? (
                            <div className='symbol symbol-35px'>
                              <img
                                src={item.orders?.item_list[0]?.image_info?.image_url}
                                alt={item.orders?.item_list[0]?.image_info?.image_url}
                              />
                            </div>
                          ) : null}
                        </div>
                      </td>
                      <td>{generateCurrencyFormat(item.orders?.total_amount ?? 0)}</td>
                      <td>
                        {generateCurrencyFormat(
                          item.orders?.total_amount - item.payout_amount
                        )}
                      </td>
                      <td>{generateCurrencyFormat(item.payout_amount)}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          <div className='card-footer'>
            <ReactPaginate
              previousLabel={'«'}
              nextLabel={'»'}
              breakLabel={'...'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              pageCount={settlementModel?.data?.total_pages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={10}
              onPageChange={handlePageClick}
              containerClassName={'pagination pagination-sm m-0 float-right'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </div>
        </div>
      </KTCard>
    </>
  )
}

const SettlementShopeeListWrapper = () => {
  return (
    <>
      <SettlementShopeeListComponent />
    </>
  )
}

export default SettlementShopeeListWrapper
